
import { Component, Inject, Vue } from "vue-property-decorator";
import { Container } from "inversify";
import FilterContainer from "../../../molecules/organization/FilterContainer.vue";
import LoadingOverlay from "../../../../../common/src/components/LoadingOverlay.vue";
import InlineFormTreeselect from "../../../../../landing/src/molecules/form/InlineFormTreeselect.vue";
import FormInput from "../../../../../landing/src/molecules/form/FormInput.vue";
import NoRecords from "../../../../../common/src/components/NoRecords.vue";
import { AuthStore } from "../../../../../common/src/stores/AuthStore";
import { ProfilePictureStore } from "../../../../../landing/src/stores/member/profile/ProfilePictureStore";
import { NotificationStore } from "../../../../../common/src/stores/NotificationStore";

@Component({
    components: {
        FilterContainer,
        LoadingOverlay,
        InlineFormTreeselect,
        FormInput,
        NoRecords,
    },
})
export default class MyProfileSidebar extends Vue {
    @Inject("container") readonly container!: Container;
    authStore: AuthStore = this.container.get(AuthStore);
    readonly profilePictureStore: ProfilePictureStore = this.container.get(ProfilePictureStore);
    readonly notificationStore: NotificationStore = this.container.get(NotificationStore);

    profileNavigation = [
        {
            label: "Personal Information",
            to: "/profile",
        },
        {
            label: "Subscriptions",
            to: "/profile/subscriptions",
        },
        {
            label: "My Requests",
            to: "/profile/requests",
        },
        {
            label: "Affiliations",
            to: "/profile/affiliations",
        },
        {
            label: "Password Reset",
            to: "/profile/password-reset",
        },
        {
            label: "Sign Out",
            action: this.signout,
        },
    ];

    mounted() {
        this.authStore.me();
    }

    async signout() {
        await this.authStore.signout();
        window.location.href = "/";
    }

    profilePictureUploadInput() {
        let fileUploadInput = document.querySelector(".file-upload") as HTMLElement;
        if (fileUploadInput) {
            fileUploadInput.click();
        }
    }

    async submitProfilePicture(input: any) {
        if (input.target.files && input.target.files[0]) {
            this.profilePictureStore.data.set("logo", input.target.files[0]);
            await this.profilePictureStore.submit();

            if (this.profilePictureStore.failed) {
                this.notificationStore.warning("Updating profile picture failed.");
            } else {
                this.notificationStore.success("Profile picture has been updated.");
                // Reload logo
                await this.authStore.me();
            }
        }
    }
}
